<template lang="pug">
  .main
    .main__content-wr
      .main__content-slider
        Slider(:items="sliderItems" v-if="sliderItems")
      .main__content-block
        .main__content-text-block
          .main__content-title ПАНОРАМНЫЙ РЕСТОРАН
          .main__content-sub-title Европейская и Паназиатская кухня
        img.main__content-logo(src="/img/logo.svg")
        .main__content-btn(type="button", v-on:click="popupLocal('booking', 'show')") ЗАБРОНИРОВАТЬ СТОЛ
    Samedia
</template>

<script>
import EventBus from '@/eventBus';
import Samedia from '@/components/common/samedia/Samedia.vue';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

import Slider from '@/components/common/slider/Slider.vue';

export default {
  name: 'Main',

  mixins: [AjaxHelpersVue, PopupHelpersVue],

  data() {
    return {
      sliderItems: null,
      mainBanner: false,
      firstLoad: false,
      elementHide: false,
      swiperInstance: null,
    }
  },

  components: {
    Slider,
    Samedia
  },

  created() {
    EventBus.$on('loadMainPage', url => {
      this.request(url);
    });
    EventBus.$on('firstLoad', url => {
      if (url === '/') {
        this.firstLoad = true;
      }
    });
  },

  methods: {
    request(url) {
      this.req('MainPage:getPage', {url}, res => {

        if (this.checkProperty(res.content.mainBanner)) {
          this.mainBanner = res.content.mainBanner;
        }

        this.sliderItems = res.content.slider

        if (this.firstLoad === true && url === '/') {
          this.elementHide = true;
          this.firstLoad = false;
          setTimeout(() => {
            this.elementHide = false;
          }, 500)
        }
        EventBus.$emit('pageDone');
      }, 'main');
    },

    initSlider() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
        initialSlide: 1,
        centeredSlides: true,
        slidesPerView: 3,
        spaceBetween: 0,
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
          }
        }
      });
    },

    popupLocal(type, action) {
      this.popup(type, action);
    }
  }
}
</script>
